import { useEffect, useState } from 'react';
import { authApi } from '../../../api/authApi';

const EMPTY_FORM = { email: '', password: '' };

const signInWith = (token, email) => {
  localStorage.setItem('diploAccessKey', token);
  localStorage.setItem('diploAccessUser', email);
  window.location.href = '/';
};

const validate = ({ email, password }) => {
  const errors = {};
  if (!email) errors.email = 'Email is required';
  else if (!/\S+@\S+\.\S+/.test(email)) errors.email = 'Email is not valid';
  if (!password) errors.password = 'Password is required';
  return errors;
};

/** SSO sends the user back with ?access_token=…&email=…; finish the sign-in from there. */
const useSsoCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('access_token');
    const email = params.get('email');
    if (token && email) signInWith(token, email);
  }, []);
};

/** Email/password and SSO sign-in: form values, field errors, and the two submit actions. */
export function useLoginForm() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [ssoLoading, setSsoLoading] = useState(false);
  useSsoCallback();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (fieldErrors[name]) setFieldErrors((prev) => ({ ...prev, [name]: '' }));
    if (loginError) setLoginError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(form);
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setIsSubmitting(true);
    setLoginError('');
    try {
      const response = await authApi.login({ email: form.email, password: form.password });
      if (response.access_token) signInWith(response.access_token, form.email);
      else setLoginError('Login successful but no access token received');
    } catch (error) {
      console.error('Login error:', error);
      setLoginError(error.message || 'Login failed. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSsoLogin = () => {
    setSsoLoading(true);
    setLoginError('');
    authApi
      .getSSORedirect()
      .then((redirectUrl) => {
        window.location.href = redirectUrl;
      })
      .catch((error) => {
        console.error('SSO redirect error:', error);
        setLoginError('SSO login failed. Please try again later.');
        setSsoLoading(false);
      });
  };

  return { form, fieldErrors, isSubmitting, loginError, ssoLoading, handleChange, handleSubmit, handleSsoLogin };
}
